var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParallel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#BDF8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54183 11.3752H3.91683C3.59483 11.3752 3.3335 11.1138 3.3335 10.7918C3.3335 10.4698 3.59483 10.2085 3.91683 10.2085H6.54183C6.86383 10.2085 7.12516 10.4698 7.12516 10.7918C7.12516 11.1138 6.86383 11.3752 6.54183 11.3752Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54167 16.0415H4.9375C3.97267 16.0415 3.1875 15.2563 3.1875 14.2915V7.2915C3.1875 6.32667 3.97267 5.5415 4.9375 5.5415H6.54167C6.86367 5.5415 7.125 5.80284 7.125 6.12484C7.125 6.44684 6.86367 6.70817 6.54167 6.70817H4.9375C4.61608 6.70817 4.35417 6.97009 4.35417 7.2915V14.2915C4.35417 14.6129 4.61608 14.8748 4.9375 14.8748H6.54167C6.86367 14.8748 7.125 15.1362 7.125 15.4582C7.125 15.7802 6.86367 16.0415 6.54167 16.0415Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12484 10.7915H4.354V11.3748H6.5415C6.8635 11.3748 7.12484 11.1135 7.12484 10.7915Z",
    fill: "#546D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35417 10.7915H3.1875V14.2915C3.1875 15.2563 3.97267 16.0415 4.9375 16.0415H6.54167C6.86367 16.0415 7.125 15.7802 7.125 15.4582C7.125 15.1362 6.86367 14.8748 6.54167 14.8748H4.9375C4.61608 14.8748 4.35417 14.6129 4.35417 14.2915V11.3748V10.7915Z",
    fill: "#546D79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1457 4.0835H8.14567C7.01984 4.0835 6.104 4.99933 6.104 6.12516C6.104 7.251 7.01984 8.16683 8.14567 8.16683H15.1457C16.2715 8.16683 17.1873 7.251 17.1873 6.12516C17.1873 4.99933 16.2715 4.0835 15.1457 4.0835Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1457 8.75H8.14567C7.01984 8.75 6.104 9.66583 6.104 10.7917C6.104 11.9175 7.01984 12.8333 8.14567 12.8333H15.1457C16.2715 12.8333 17.1873 11.9175 17.1873 10.7917C17.1873 9.66583 16.2715 8.75 15.1457 8.75Z",
    fill: "#0097A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1457 13.4165H8.14567C7.01984 13.4165 6.104 14.3323 6.104 15.4582C6.104 16.584 7.01984 17.4998 8.14567 17.4998H15.1457C16.2715 17.4998 17.1873 16.584 17.1873 15.4582C17.1873 14.3323 16.2715 13.4165 15.1457 13.4165Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6457 4.0835H8.14567C7.01984 4.0835 6.104 4.99933 6.104 6.12516C6.104 7.251 7.01984 8.16683 8.14567 8.16683H11.6457V4.0835Z",
    fill: "#00A4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6457 8.75H8.14567C7.01984 8.75 6.104 9.66583 6.104 10.7917C6.104 11.9175 7.01984 12.8333 8.14567 12.8333H11.6457V8.75Z",
    fill: "#008391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6457 13.4165H8.14567C7.01984 13.4165 6.104 14.3323 6.104 15.4582C6.104 16.584 7.01984 17.4998 8.14567 17.4998H11.6457V13.4165Z",
    fill: "#00A4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72933 11.3747C9.0515 11.3747 9.31266 11.1135 9.31266 10.7913C9.31266 10.4692 9.0515 10.208 8.72933 10.208C8.40716 10.208 8.146 10.4692 8.146 10.7913C8.146 11.1135 8.40716 11.3747 8.72933 11.3747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 11.3747C11.968 11.3747 12.2292 11.1135 12.2292 10.7913C12.2292 10.4692 11.968 10.208 11.6458 10.208C11.3237 10.208 11.0625 10.4692 11.0625 10.7913C11.0625 11.1135 11.3237 11.3747 11.6458 11.3747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72933 16.0417C9.0515 16.0417 9.31266 15.7805 9.31266 15.4583C9.31266 15.1362 9.0515 14.875 8.72933 14.875C8.40716 14.875 8.146 15.1362 8.146 15.4583C8.146 15.7805 8.40716 16.0417 8.72933 16.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 16.0417C11.968 16.0417 12.2292 15.7805 12.2292 15.4583C12.2292 15.1362 11.968 14.875 11.6458 14.875C11.3237 14.875 11.0625 15.1362 11.0625 15.4583C11.0625 15.7805 11.3237 16.0417 11.6458 16.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72933 6.70817C8.40733 6.70817 8.146 6.44684 8.146 6.12484C8.146 5.80284 8.40733 5.5415 8.72933 5.5415C9.05133 5.5415 9.31266 5.80284 9.31266 6.12484C9.31266 6.44684 9.05133 6.70817 8.72933 6.70817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 6.70817C11.3238 6.70817 11.0625 6.44684 11.0625 6.12484C11.0625 5.80284 11.3238 5.5415 11.6458 5.5415C11.9678 5.5415 12.2292 5.80284 12.2292 6.12484C12.2292 6.44684 11.9678 6.70817 11.6458 6.70817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31266 6.125H8.146C8.146 6.447 8.40733 6.70833 8.72933 6.70833C9.05133 6.70833 9.31266 6.447 9.31266 6.125Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2292 6.125H11.0625C11.0625 6.447 11.3238 6.70833 11.6458 6.70833C11.9678 6.70833 12.2292 6.447 12.2292 6.125Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31266 10.7915H8.146C8.146 11.1135 8.40733 11.3748 8.72933 11.3748C9.05133 11.3748 9.31266 11.1135 9.31266 10.7915Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2292 10.7915H11.0625C11.0625 11.1135 11.3238 11.3748 11.6458 11.3748C11.9678 11.3748 12.2292 11.1135 12.2292 10.7915Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31266 15.4585H8.146C8.146 15.7805 8.40733 16.0418 8.72933 16.0418C9.05133 16.0418 9.31266 15.7805 9.31266 15.4585Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2292 15.4585H11.0625C11.0625 15.7805 11.3238 16.0418 11.6458 16.0418C11.9678 16.0418 12.2292 15.7805 12.2292 15.4585Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(3.1875 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallel);
export default __webpack_public_path__ + "static/media/Parallel.507ecc4c1d28f6618f3a3923a06beedf.svg";
export { ForwardRef as ReactComponent };